
import React from "react";
// nodejs library that concatenates strings
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
import logo from '../../assets/img/pharos/logos/White_pharos_logoHorizontal_Retina_alpha.png'
import logo2 from '../../assets/img/pharos/logos/pharos_logoHorizontal_Retina_alpha.png'
import LocalAtmIcon from '@mui/icons-material/LocalAtm';

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);
  const [icon, setIcon] = React.useState(logo);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setIcon(logo2)
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setIcon(logo)
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });


  return (
    <Navbar className={classnames("fixed-top")} expand="lg" style={{backgroundColor:'#000000', opacity:.8}}>
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            href="/index"
            target="_blank"
          >
            <img style={{width:100, height: 30}} src={logo}/>
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>      
            <NavItem>
              <NavLink
                href="#inicio"
                onClick={(e) => e.preventDefault()}
              >
                INICIO
              </NavLink>
             {/*  <div style={{backgroundColor:'white', height:3}}/> */}
            </NavItem>
            <NavItem>
              <NavLink
                href="#nosotros"
                onClick={(e) => e.preventDefault()}
              >
            
                NOSOTROS
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#servicios"
                onClick={(e) => e.preventDefault()}
              >
                SERVICIOS
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#contacto"
                onClick={(e) => e.preventDefault()}
              >
                CONTACTO
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://backoffice.pharospayments.com/"
              >
                <LocalAtmIcon style={{marginRight:10}}/>
                INGRESAR
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
